import firebase from 'firebase/app';
import { saveSearch } from '../../../../../dashboard/components/Functions/SaveSearch/SaveSearch';

export const AddContact = async(fbProfile, profile, LIurl, interests, auth, foundInts) => {

    const msg = '';

    var newDoc = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc()    
    
    await newDoc
        .set({
            CreatedBy: fbProfile.email,
            Company: fbProfile.company,
            Linkedin: LIurl,
            ProspectName: profile?.full_name ? profile?.full_name : '',
            ProspectCompany: (profile?.experiences?.length > 0) ? profile?.experiences[0]?.company : '',
            ProspectRole: profile?.occupation ? profile?.occupation : '',
            ProspectInterest: interests,
            ProspectContent: '',
            contactImg: profile?.profile_pic_url,
            contactEducation: profile?.education?.length > 0 ? profile?.education[0]?.school : '',
            contactFieldOfStudy: profile?.education?.length > 0 ? profile?.education[0]?.field_of_study : '',
            contactHeadline: profile?.headline,
            contactCity: profile?.city,
            contactSummary: profile?.summary ? profile?.summary : '',
            createdAt: new Date(),
            AuthorID: auth.uid,
            AuthorFirstName: fbProfile.firstName,
            AuthorLastName: fbProfile.lastName,
            MessageApproved: 'No',
            MessageSent: 'No',
            InterestPreAi: foundInts,
            CreatedfromApp: "Yes",
            CreatedfromCext: "No",
    }).then(() =>{
        firebase
        .firestore()
        .collection('organizations')
        .doc(fbProfile.company)
        .collection('checkedContacts')
        .doc(newDoc.id)
        .set({
            CreatedBy: fbProfile.email,
            Company: fbProfile.company,
            Linkedin: LIurl,
            ProspectName: profile?.full_name ? profile?.full_name : '',
            ProspectCompany: (profile?.experiences?.length > 0) ? profile?.experiences[0]?.company : '',
            ProspectRole: profile?.occupation ? profile?.occupation : '',
            ProspectInterest: interests,
            ProspectContent: '',
            contactImg: profile?.profile_pic_url ? profile?.profile_pic_url : '',
            contactEducation: profile?.education?.length > 0 ? profile?.education[0]?.school : '',
            contactFieldOfStudy: profile?.education?.length > 0 ? profile?.education[0]?.field_of_study : '',
            contactHeadline: profile?.headline,
            contactCity: profile?.city,
            contactSummary: profile?.summary ? profile?.summary : '',
            contactExp: profile?.experiences ? profile?.experiences : '',
            createdAt: new Date(),
            AuthorID: auth.uid,
            AuthorFirstName: fbProfile.firstName,
            AuthorLastName: fbProfile.lastName,
            MessageApproved: 'No',
            MessageSent: 'No',
            InterestPreAi: foundInts,
            CreatedfromApp: "Yes",
            CreatedfromCext: "No",
    }).then(() =>{
        saveSearch(fbProfile, auth, profile, LIurl, interests, msg, foundInts, newDoc.id)
        // setShowSpinn(false)
    })
    })

    

}
